module.exports = __webpack_public_path__ + "media/images/icons/v2/chevron-right-06c13b2b40e1a0034eac2639c52d3ae2.svg";